import { computed, type Ref } from 'vue';

export const useProjectProfitTableCost = ({
	costBudgeted,
	costRecognized,
	costForecasted,
	costInvoiced,
}: {
	costBudgeted: Ref<number>;
	costRecognized: Ref<number>;
	costForecasted: Ref<number>;
	costInvoiced: Ref<number>;
}) => {
	const costToRecognize = computed(
		() => costBudgeted.value - costRecognized.value
	);

	// Round to 2dp to avoid IEEE 754 epsilon errors when the backend sends
	// costForecasted = budget - recognized and we add recognized back here.
	const costForecastedTotal = computed(
		() =>
			Math.round((costForecasted.value + costRecognized.value) * 100) /
			100
	);

	const isCostRecognizedOverBudget = computed(
		() => costBudgeted.value < costRecognized.value
	);

	const isCostForecastedOverBudget = computed(
		() => costBudgeted.value < costForecastedTotal.value
	);

	const isCostInvoicedOverBudget = computed(
		() => costBudgeted.value < costInvoiced.value
	);

	return {
		costToRecognize,
		costForecastedTotal,
		isCostRecognizedOverBudget,
		isCostForecastedOverBudget,
		isCostInvoicedOverBudget,
	};
};
